import { useState, useEffect } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { useLenis } from "@/hooks/useLenis";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { Portfolio } from "@/components/Portfolio";
import { FeaturedProject } from "@/components/FeaturedProject";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";

const Loader = ({ done }) => (
  <div
    data-testid="preloader"
    className={`fixed inset-0 z-[100] bg-[var(--ink)] flex items-center justify-center transition-[opacity,visibility] duration-700 ${
      done ? "opacity-0 invisible" : "opacity-100 visible"
    }`}
  >
    <div className="overflow-hidden">
      <img
        src="/dopman-logo.png"
        alt="DOPMAN B.V."
        className="h-12 md:h-16 w-auto brightness-0 invert animate-[loaderUp_1s_cubic-bezier(0.16,1,0.3,1)_forwards]"
      />
    </div>
    <style>{`@keyframes loaderUp{0%{transform:translateY(115%)}45%,100%{transform:translateY(0)}}`}</style>
  </div>
);

function App() {
  useLenis();
  const params = typeof window !== "undefined" ? new URLSearchParams(window.location.search) : new URLSearchParams();
  const onlyPortfolio = params.get("only") === "portfolio";
  const onlyProject = params.get("only") === "project";
  const [loaded, setLoaded] = useState(() => onlyPortfolio || onlyProject || params.has("skip"));

  useEffect(() => {
    const finish = () => setLoaded(true);
    const t = setTimeout(finish, 1500);
    window.addEventListener("wheel", finish, { once: true });
    window.addEventListener("touchstart", finish, { once: true });
    window.addEventListener("pointerdown", finish, { once: true });
    window.addEventListener("keydown", finish, { once: true });
    return () => {
      clearTimeout(t);
      window.removeEventListener("wheel", finish);
      window.removeEventListener("touchstart", finish);
      window.removeEventListener("pointerdown", finish);
      window.removeEventListener("keydown", finish);
    };
  }, []);

  return (
    <div className="App grain">
      <Loader done={loaded} />
      <Toaster position="top-center" theme="light" richColors />
      {onlyPortfolio ? (
        <Portfolio />
      ) : onlyProject ? (
        <FeaturedProject />
      ) : (
        <>
          <Header />
          <main>
            <Hero />
            <Marquee />
            <About />
            <Services />
            <Process />
            <Portfolio />
            <FeaturedProject />
            <Contact />
          </main>
          <Footer />
          <WhatsAppButton />
        </>
      )}
    </div>
  );
}

export default App;
